import { DefaultError, useMutation } from "@tanstack/react-query";
import { sendPasswordResetEmail } from "../api";
import createAdmin, { CreateAdminParams } from "../api/createAdmin";
import { invalidateAdminListQuery } from "../queries/useAdminListQuery";

const useCreateAdminMutation = (onSuccess: () => void) => {
  return useMutation<unknown, DefaultError, CreateAdminParams>({
    mutationFn: async (params) => {
      await createAdmin(params);
    },
    onSuccess: async (_, params) => {
      onSuccess();
      await Promise.all([
        sendPasswordResetEmail(params.email),
        invalidateAdminListQuery(),
      ]);
    },
    onError: (e) => {
      alert(e.message);
    },
  });
};

export default useCreateAdminMutation;
